import {useAppDispatch} from '../../../../../../helpers/reduxHelpers';
import {
  createAndAddTopicToConversationsAsyncAction,
  removeTopicFromConversationsAction,
} from '../../../../../../store/data/conversations/topicConversationsActions';
import {InboxesVisualConversationSelection} from '../../../../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';

export function useConversationsHandlers(
  conversationSelection: InboxesVisualConversationSelection,
  topicId: number,
) {
  const dispatch = useAppDispatch();

  if (!conversationSelection.isFullyKnown) {
    return {};
  }

  const conversationIds = conversationSelection.knownIds;

  return {
    createAndAddTopic: (link: string, name: string) => {
      dispatch(createAndAddTopicToConversationsAsyncAction(conversationIds, link, name));
    },
    removeTopic: () => {
      dispatch(removeTopicFromConversationsAction(conversationIds, topicId));
    },
  };
}
